/**
 * Inclusive calendar-day check in Europe/Warsaw.
 * `endsOn` is `YYYY-MM-DD` — promo is active through the end of that day.
 */
export function isPromotionActiveOnDate(
  endsOn: string,
  now: Date = new Date(),
): boolean {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Warsaw',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
  const todayWarsaw = formatter.format(now) // YYYY-MM-DD
  return todayWarsaw <= endsOn
}
